import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getConfig } from '../../config';
import { useDueDate } from '../../contexts/dueDateContext';
import apiServicewt from '../../api/apiServicewt';

const DueDateStatusLoader = ({ setShowOverlay }) => {
	const { setDueDateStatus, setReqStatus } = useDueDate();
	const navigate = useNavigate();

	useEffect(() => {
		const fetchServices = async () => {
			setReqStatus('loading');

			const item = { action: 'check_status' };
			try {
				const config = getConfig();
				const flechdata = await apiServicewt(item, navigate);

				if (flechdata.type === 'error') {
					setReqStatus('error');
					setShowOverlay(true);
					return;
				}

				setReqStatus('success');

				if (flechdata.customer_link) {
					config.REACT_APP_REDIRECT_CUSTOMER_LINK = flechdata.customer_link;
				}
				if (flechdata.employee_link) {
					config.REACT_APP_REDIRECT_EMPLOYEE_LINK = flechdata.employee_link;
				}

				if (!flechdata.billing_date) {
					return;
				}

				const billingDate = new Date(flechdata.billing_date);
				const currentDate = new Date().getTime();

				const billingDateMinus14 = new Date(billingDate);
				billingDateMinus14.setDate(billingDateMinus14.getDate() - 14);

				let status;

				if (billingDateMinus14 <= currentDate && currentDate <= billingDate.getTime()) {
					status = 'WARNING';
				} else if (currentDate > billingDate.getTime()) {
					status = 'INVALID';
				} else {
					status = 'VALID';
				}

				config.REACT_APP_DUE_DATE_STATUS = status;
				setDueDateStatus(status);
			} catch (error) {
				setReqStatus('error');
				console.error('Error fetching services:', error);
			}
		};

		fetchServices();
	}, [navigate, setShowOverlay, setDueDateStatus, setReqStatus]);

	return null;
};

export default DueDateStatusLoader;
